const types = {
    ADD_EVENT: 'LIFECYCLE/ADD_EVENT',
    PICO_READY: 'LIFECYCLE/PICO_READY',
    MUTATORS_READY: 'LIFECYCLE/MUTATORS_READY',
}

const creators = {
    addEvent: ({ payload } = {}) => ({ type: types.ADD_EVENT, payload }),
    picoReady: () => ({ type: types.PICO_READY }),
    mutatorsReady: () => ({ type: types.MUTATORS_READY }),
}

export {
    types,
    creators,
}
